import { useState } from 'react';
import { observer } from 'mobx-react';
import QuestionareStore from '../stores/QuestionareStore';

const RatingSlider = ({ratingKey, maxLimit}) => {
//   const [rating, setRating] = useState(3); 

  const handleChange = (e) => {
    // setRating(Number(e.target.value));
    QuestionareStore.setRatingValue(ratingKey, Number(e.target.value));
  };

  return (
    <div style={{ width: '300px', margin: '20px auto', textAlign: 'center' }}>
      <input
        type="range"
        min="1"
        max={maxLimit}
        step="1"
        value={QuestionareStore.getRatingValue(ratingKey)}
        onChange={handleChange}
        style={{ width: '100%' }}
      />
      <div style={{ marginTop: '10px', fontSize: '20px' }}>
        {QuestionareStore.getRatingValue(ratingKey)}
      </div>
    </div>
  );
};

export default observer(RatingSlider);
